import React from 'react';
import TemplatePage from '../../components/TemplatePage/TemplatePage';
import { commerceData } from '../../data/departmentalData/commerce';

const Commerce = () => {
  return <TemplatePage data={commerceData} />;
};

export default Commerce;
